// extracted by css-extract-rspack-plugin
export default {"cls1":"UserTooltip-cls1_zS3","cls2":"UserTooltip-cls2_mh8 UserTooltip-cls1_zS3"};